<template>
    <div class="flex flex-col justify-between cust-height">
        <stripe-element-card class="text-sm font-semibold text-center text-red-500"
            :pk="publishableKey"
            ref="elementRef"
            @token="tokenCreated"
        />
        <button v-show="!inProcess" class="px-8 py-2 text-xl tracking-wider text-center text-white bg-green-500 border rounded-md hover:border-green-500 hover:bg-green-100 hover:text-green-500" @click="submit">PAY NOW</button>
        <button v-show="inProcess" class="px-8 py-2 text-xl tracking-wider text-center text-white bg-green-500 border rounded-md">
            <i class="fa fa-circle-o-notch fa-spin"></i> Processing
        </button>
    </div>
</template>
<script>
    import { StripeElementCard } from '@vue-stripe/vue-stripe';
    
    export default {
        props: ['event', 'reservationData', 'mode'],
        components: {
            StripeElementCard
        },
        data() {
            return {
                publishableKey: process.env.MIX_STRIPE_PUBLISHABLE_KEY,
                inProcess: false,
                token: null,
            };
        },
        methods: {
            submit () {
                this.inProcess = true;
                this.$refs.elementRef.submit();
            },
            tokenCreated (token) {
                let custObj = this;
                if(token.id) {
                    custObj.inProcess = true;
                    axios.post('/api/stripe-payment', {
                        token : token.id,
                        type: 1,
                        amount: custObj.event.price,
                        email: custObj.reservationData.email,
                        name: custObj.reservationData.name,
                        last_name:custObj.reservationData.last_name,
                        phone: custObj.reservationData.phone,
                        company: custObj.reservationData.company,
                        role: custObj.reservationData.company_role,
                        city: custObj.reservationData.city,
                        province: custObj.reservationData.province,
                        event: custObj.event.id,
                        invoice_type: custObj.reservationData.invoice_type,
                        fiscal_code: custObj.reservationData.fiscal_code,
                        vat_number: custObj.reservationData.vat_number,
                        sd_code: custObj.reservationData.sd_code,
                        address: custObj.reservationData.address,
                        mode: custObj.mode
                    }, {'Content-Type': 'application/json'}).then(function (response) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'Payment done successfully, Please check mail for more detail!!',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        window.location.reload();
                    })
                    .catch(function (error) {
                        custObj.inProcess = false;
                        Swal.fire("Errore", "qualcosa è andato storto, riprova", "error");
                    });
                } else {
                    custObj.inProcess = false;
                    Swal.fire("Errore", "qualcosa è andato storto, riprova", "error");
                }
            },
        }
    }
</script>
<style scoped>
    .cust-height{
        min-height: 9rem;
    }
</style>